<template>
    <div>
        <div class="title">报名信息</div>
        <div class="content">
            <div class="info-box">
                <table class="info-box-item" cellspacing="0" cellpadding="0">
                    <tr class="info-item">
                        <td class="item-label">状态</td>
                        <td class="item-content" v-if="info.status == -1" style="color: orange">
                            完善资料
                        </td>
                        <td class="item-content" v-if="info.status == 1" style="color: green">
                            审核成功
                        </td>
                        <td class="item-content" v-if="info.status == 2" style="color: red">
                            审核失败
                        </td>
                    </tr>
                    <tr class="info-item">
                        <td class="item-label">姓名</td>
                        <td class="item-content">{{ info.username}}</td>
                    </tr>
                    <tr class="info-item">
                        <td class="item-label">身份证号</td>
                        <td class="item-content">{{ info.idcard}}</td>
                    </tr>
                    <tr class="info-item">
                        <td class="item-label">手机号码</td>
                        <td class="item-content">{{ info.phone}}</td>
                    </tr>
                    <tr class="info-item">
                        <td class="item-label">报名项目</td>
                        <td class="item-content">{{ info.project_name}}</td>
                    </tr>
                    <tr class="info-item">
                        <td class="item-label">报名期数</td>
                        <td class="item-content">{{ info.class_name}}</td>
                    </tr>
                    <tr class="info-item">
                        <td class="item-label">审核说明</td>
                        <td class="item-content">{{ info.remark}}</td>
                    </tr>
                    <tr class="info-item" v-if="info.status == -1">
                        <td class="item-label">资历示例图</td>
                        <td class="item-content">
                            <img src="http://recruit.rzmevc.com/upload/images/8KYSwtDNvnr9nRzt5x.png"
                                 @click="handleImgPreview('http://recruit.rzmevc.com/upload/images/8KYSwtDNvnr9nRzt5x.png')"
                                 class="eg-img" alt="">


                        </td>
                    </tr>
                </table>
            </div>
            <div class="tip" v-if="info.status == -1">
                <div class="tip-txt">注意：</div>
                <div class="tip-txt">1、请上传海事综合服务平台-船员综合信息查询-任解职登记信息。</div>
                <div class="tip-txt">2、学生个人信息姓名、身份证号显示完整。</div>
                <div class="tip-txt">3、资历满足培训要求。</div>
            </div>
            <table class="info-box-item1" cellspacing="0" cellpadding="0" v-if="info.status == -1">
                <tr class="info-item1">
                    <td class="item-label">
                        海事综合服务平台资历截图

                    </td>
                    <td class="item-content">
                        <el-upload
                                class="uploadCom"
                                list-type="picture-card"
                                accept="image/jpeg,image/gif,image/png,image/jpg"
                                multiple
                                :limit="9"
                                :file-list="fileList"
                                :action=uploadUrl
                                :show-file-list="true"
                                :headers="headers"
                                :on-exceed="handleLimit"
                                :on-success="handleAvatarSuccess">
                            <i slot="default" class="el-icon-plus"></i>
                            <div slot="file" slot-scope="{file}">
                                <!--                                {{file}}-->
                                <!--                                <div v-for="(img,index) in uploadImgs" :key="index">-->
                                <!--                                    <img  :src="img" class="el-upload-list__item-thumbnail">-->
                                <!--                                </div>-->
                                <img :src="file.url" class="el-upload-list__item-thumbnail">
                                <span class="el-upload-list__item-actions">
                                <span class="el-upload-list__item-preview"
                                      @click="handlePictureCardPreview(file)">
                                        <i class="el-icon-zoom-in"></i>
                                </span>
                                <span v-if="!disabled"
                                      class="el-upload-list__item-delete"
                                      @click="handleRemove(file)">
                                    <i class="el-icon-delete"></i>
                                </span>
                                </span>
                            </div>

                        </el-upload>
                    </td>
                </tr>
            </table>
            <div style="margin-top: 20px">
                <el-button v-if="info.status != -1" @click="goLastPage" class="cancel-btn">返回</el-button>
                <el-button v-if="info.status == -1" type="primary" @click="submitForm('ruleForm')" class="submit-btn">确认</el-button>

            </div>
        </div>
        <el-dialog
                :width="myWidth"
                :visible.sync="dialogVisible">
            <img width="100%" :src="dialogImageUrl" alt="">
        </el-dialog>
        <el-dialog
                :visible.sync="showTip"
                :width="myWidth"
                :show-close="false"
                :close-on-click-modal="false"
                center>
            <div class="dialogInfo">报名信息提交成功，需经审核，审核结果后期会以短信的形式发送到联系人手机上！</div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="hideShowTip" class="close-btn">关闭</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import {urlConfig} from '@/common/urlConfig'

    export default {
        name: "info",
        data() {
            return {
                ruleForm: {
                    username: '', // 姓名
                    idcard: '', // 身份证号码
                    phone: '', // 电话号码
                    code: '', // 验证码
                    job: '水手', // 职务
                    recommend_name: '', // 推荐人姓名
                    recommend_phone: '', // 推荐人手机号
                    file: '', // 图片
                    region: '',
                    date1: '',
                    date2: '',
                    delivery: false,
                    type: [],
                    desc: '',
                },
                rules: {
                    file: [
                        {required: true, message: '请上传图片', trigger: 'change'}
                    ],
                },
                dialogImageUrl: '',
                dialogVisible: false,
                disabled: false,
                checked: true,
                projectOptions: [{
                    title: '',
                    enroll_class: [
                        {
                            title: '',
                            has_quota: 0
                        }
                    ]
                }], // 项目列表
                projectIndex: 0, // 列表index
                enrollOptions: [{
                    title: '',
                    has_quota: 0
                }], // 期数列表
                enrollIndex: 0, //期数index
                has_quota: 0, //名额
                jobOption: [
                    {
                        label: '水手'
                    },
                    {
                        label: '机工'
                    }
                ],
                value: '',
                access_token: '',
                headers: {
                    "Authorization": "",
                },
                uploadUrl: urlConfig + 'uploadImg',
                uploadImgs: [], // 图片
                fileList: [], // 上传的文件列表
                times: 60,
                timer: null,
                show: true,
                record_id: null, // 记录id
                showTip: false, //显示确认弹窗
                span: 15,
                smSpan: 16,
                codeSmSpan: 10,
                labelPosition: 'right',
                myWidth: '40%',
                info: {},
            };
        },
        created() {
            this.access_token = localStorage.getItem('access_token')
            this.headers.Authorization = localStorage.getItem('access_token')
            this.info = JSON.parse(localStorage.getItem('info'))
            if(this.info.status == -1) {
                this.uploadImgs = this.info.files.split(',')
                let fileList = this.info.files.split(',')
                fileList.map((i, n) => {
                    this.fileList.push({
                        name: n,
                        url: i
                    })
                })
            }


        },
        mounted() {
            let that = this;
            that.resizeSpan();
            window.onresize = function() {
                that.resizeSpan();
            }

        },
        methods: {
            // 重新设置span大小
            resizeSpan() {
                let w = document.documentElement.offsetWidth || document.body.offsetWidth;
                // console.log('w', w)
                if(w>768) {
                    this.span = 15;
                    this.labelPosition = 'right'
                    this.smSpan = 16;
                    this.codeSmSpan = 10;
                    this.myWidth = '40%'
                }
                if(w <= 768) {
                    this.span = 6;
                    this.labelPosition = 'left'
                    this.smSpan = 24;
                    this.codeSmSpan = 6;
                    this.myWidth = '90%'
                }
                if(w < 600) {
                    this.span = 9;
                }
                if(w < 500) {
                    this.span = 11;
                }
                if(w < 400) {
                    this.span = 13;
                }
            },
            // 超过图片限制
            handleLimit(file) {
                // console.log('file', file);
                if(this.fileList.length + file.length > 9) {
                    this.$message.error('最多可以上传9张图片')
                }
            },
            // 上传图片成功
            handleAvatarSuccess(res, file, fileList) {
                console.log('res', res, file, fileList);
                this.uploadImgs.push(res.data);
                this.fileList = fileList;
                this.ruleForm.file = this.uploadImgs.join(',');
                // this.ruleForm.file = res.data;
                console.log('uploadImgs', this.uploadImgs)
            },
            // 上传图片之前
            beforeAvatarUpload(file) {
                // console.log('file', file);
                const isLt2M = file.size / 1024 / 1024 < 2;

                if (!isLt2M) {
                    this.$message.error('上传头像图片大小不能超过 2MB!');
                }
                return isLt2M;
            },
            // 删除图片
            handleRemove(file) {
                console.log(file);
                console.log('fileList', this.fileList);
                this.fileList.map((i, n) => {
                    if (i.uid == file.uid) {
                        this.fileList.splice(n, 1);
                        this.uploadImgs.splice(n, 1);
                    }
                })
                console.log('this.uploadImgs', this.uploadImgs);
                // this.ruleForm.file = '';
            },
            // 预览图片
            handlePictureCardPreview(file) {
                console.log('file', file);
                this.dialogImageUrl = file.url;
                this.dialogVisible = true;
            },
            // 预览图片
            handleImgPreview(url) {
                this.dialogImageUrl = url;
                this.dialogVisible = true;
            },
            // 隐藏提示信息
            hideShowTip() {
                this.showTip = false;
                this.$router.push('/success');
            },
            handleDownload(file) {
                console.log(file);
            },
            // 手机号码验证
            formatTel(tel) {
                return /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/.test(tel);
            },
            // 手机号和座机号验证
            formatPhone(val) {
                return /^((0\d{2,3}-\d{7,8})|(1[3584]\d{9}))$/.test(val)
            },
            // 提交
            submitForm() {
                this.ruleForm.file = this.uploadImgs.join(',');
                if(this.uploadImgs.length == 0) {
                    this.$message.error('请上传资历截图')
                    return false;
                }
                console.log('uploadImgs', this.uploadImgs)
                let submitData = {
                    files: this.uploadImgs.join(','),
                    record_id: this.info.id
                }
                this.$request('post', 'updaterecord', submitData, {
                    Authorization: this.access_token
                }).then((res) => {
                    console.log('res', res);
                    if(res.data == 0) {
                        this.showTip = true;
                    } else {
                        this.$message.error(res.message);
                    }
                })
            },
            goLastPage() {
                this.$router.go(-1);
            },
            resetForm(formName) {
                this.$refs[formName].resetFields();
            }
        }
    }
</script>

<style scoped>
    @media only screen and (max-width: 1130px) {
        .content {
            width: 100% !important;
        }
    }
    @media only screen and (max-width: 1024px) {
        .content .info-item .item-label {
            /*width: 33% !important;*/
            /*text-align: left !important;*/
        }
        /deep/ .el-form-item__label {
            width: 33% !important;
        }
        /deep/ .el-form-item__content {
            margin-left:33% !important;
        }
        .content {
            width: 100% !important;
        }
    }
    @media only screen and (max-width: 860px) {
        .content .info-item .item-label {
            /*width: 30% !important;*/
            /*text-align: left !important;*/
        }
        /deep/ .el-form-item__label {
            width: 30% !important;
        }
        /deep/ .el-form-item__content {
            margin-left:30% !important;
        }
        .content {
            width: 100% !important;
            /*padding: 10px 15px !important;*/
            /*margin: 0 !important;*/
        }
    }
    @media only screen and (max-width: 768px) {
        .content .info-item .item-label {
            /*width: 30% !important;*/
            /*text-align: left !important;*/
        }
        .info-item1 {
            flex-wrap: wrap;
            width: auto !important;
        }
        .info-item1 .item-label {
            /*width: 100% !important;*/
            /*text-align: left !important;*/
            /*margin-bottom: 10px;*/
        }
        .info-box {
            /*width: 100% !important;*/
            border-radius: 0 !important;
            margin-top: 20px !important;
        }
        .info-box-item {
            /*width: auto !important;*/
        }
        /deep/ .el-form-item__label {
            width: 100% !important;
        }
        /deep/ .el-form-item__content {
            margin-left: 0 !important;
        }
        .content {
            width: 100% !important;
            /*padding: 10px 15px !important;*/
            /*margin: 0 !important;*/
            border: none !important;
        }
    }
    @media only screen and (max-width: 600px) {
        .tip {
            box-sizing: border-box;
            width: 100% !important;
            padding: 0 15px !important;
            margin-top: 10px !important;
            margin-bottom: 0 !important;
        }
        .info-box {
            padding: 0 15px;
            box-sizing: border-box;
        }
        .info-box-item {
            width: 100% !important;
        }
        .info-box-item1 {
            width: 100% !important;
        }
        .info-item1 {
            width: 100% !important;
            display: flex !important;
            flex-wrap: wrap;
        }
        .info-item1 .item-label {
            width: 100% !important;
            text-align: left !important;
            margin-bottom: 10px;
        }
        .info-item1 .item-content {
            width: 100% !important;
        }
    }
    .title {
        color: rgba(51, 101, 225, 1);
        font-size: 24px;
        font-weight: 600;
    }

    .content {
        /*width: 1130px;*/
        width: 60%;
        border-radius: 20px;
        /*box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.06);*/
        margin: 50px auto;
        padding: 0 0 20px;
        box-sizing: border-box;
        /*border: 1px solid #999999;*/
    }

    .info-box {
        width: 100%;
        /*background: #f0f0f0;*/
        margin: 0 auto;
        border-radius: 20px 20px 0 0;
    }
    .info-box-item {
        width: 600px;
        margin: 0 auto;
        display: table;
        border: 1px solid #ececec;
        border-bottom: none;
    }

    .content .info-item {
        /*display: flex;*/
        align-items: center;
        display: table-row;
        /*padding: 10px 0;*/
        margin: 0 auto;
        /*border-right: 1px solid #f1f1f1;*/
        border-bottom: 1px solid #ececec;



    }
    .content .info-item:last-child {
        border-bottom: 1px solid #ececec;
    }

    .content .info-item .item-label{
        color: #606266;
        font-size: 14px;
        /*width: 120px;*/
        text-align: center;
        padding: 10px;
        box-sizing: border-box;
        display: table-cell;
        background: #f0f3fa;
        /*vertical-align: top;*/
        border-right: 1px solid #ececec;
        border-bottom: 1px solid #ececec;
        min-width: 92px;
    }

    .content .info-item .item-content{
        padding: 10px;
        box-sizing: border-box;
        display: table-cell;
        border-bottom: 1px solid #f1f1f1;
    }
    .tip {

        font-size: 12px;
        color: red;
        text-align: left;
        width: 600px;
        margin: 0 auto;
        margin-top: 20px;
        margin-bottom: 10px;
    }
    .tip .tip-txt{
        /*text-indent: 24px;*/
    }
    .info-box-item1 {
        width: 600px;
        margin: 0 auto;
        display: table;
    }
    .info-item1 {
        display: table-row;
        padding: 15px;
        margin: 0 auto;
        width: 600px;
        box-sizing: border-box;
    }
    .info-item1 .item-label{
        display: table-cell;
        color: #606266;
        font-size: 14px;
        width: 220px;
        min-width: 220px;
        text-align: left;
        box-sizing: border-box;
        vertical-align: top;
    }
    .info-item1 .item-label:before{
        position: absolute;
        content: '*';
        color: red;
        margin-left: -8px;
    }

    .info-item1 .item-content{
        display: table-cell;
        /*margin-left: 10px;*/
    }
    .eg-img {
        width: 148px;
        height: 148px;
        border-radius: 6px;
    }
    .content .right {
        margin-left: 8px;
        text-align: left;
    }

    .content .right .codeBtn {
        background: rgba(51, 101, 225, 1);
        color: #ffffff;
        width: 112px;
    }
    .content .right .codeBtn1 {
        background: #BBC1D0;
        color: #ffffff;
        width: 112px;
        border: 1px solid #BBC1D0;
    }

    .content .right .retain {
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
    }

    .check {
        width: 100%;
        margin-bottom: 34px;
    }

    .submit-btn {
        background: #3365e1;
        color: #ffffff;
    }

    .cancel-btn {
        border: 1px solid #3365e1;
        color: #3365e1;
    }

    .uploadCom {
        /*width: 148px;*/
        /*height: 148px;*/
        /*overflow: hidden;*/
        text-align: left;
    }

    .dialogInfo {
        font-size: 16px;
        font-weight: 600;
        color: #000;
        line-height: 2;
        text-align: center;
    }

    .close-btn {
        background: #3365e1;
    }
    /deep/ .el-form-item {
        width: 100%;
    }

    /* 选中后的字体颜色 */
    /deep/ .el-radio__input.is-checked + .el-radio__label {
        color: #3365e1 !important;
    }

    /* 选中后小圆点的颜色 */
    /deep/ .el-radio__input.is-checked .el-radio__inner {
        background: #3365e1 !important;
        border-color: #3365e1 !important;
    }

    /deep/ .btn-group .el-form-item__content {
        margin-left: 0 !important;
    }

    /deep/ .el-checkbox__input.is-checked .el-checkbox__inner,
    /deep/ .el-checkbox__input.is-indeterminate .el-checkbox__inner {
        border-color: #3365e1 !important;
        background-color: #3365e1 !important;
    }

    /deep/ .el-checkbox__input.is-checked + .el-checkbox__label {
        color: #3365e1 !important;
    }

    /deep/ .el-checkbox__inner:hover {
        border-color: #3365e1 !important;
    }

    /deep/ .el-checkbox__input.is-focus .el-checkbox__inner {
        border-color: #3365e1 !important;
    }
    /deep/ .el-radio__input.is-disabled+span.el-radio__label {
        color: #C0C4CC;
        cursor: default;
    }

</style>
